var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"block-ui-overlay\">\n</div>\n<div class=\"block-ui-message-container\" aria-live=\"assertive\" aria-atomic=\"true\">\n<div class=\"block-ui-message md-hue-2\" ng-class=\"$_blockUiMessageClass\">\n<div>{{ state.message }}</div>\n<md-progress-circular md-theme=\"success\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"100px\"></md-progress-circular>\n</div>\n</div>";
var id1="assets/content/blockui-template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/assets/content/blockui-template.html
// module id = 660
// module chunks = 0